module.exports = __webpack_public_path__ + "img/11088031_L.b3f21360.png";